import classNames from 'classnames';
import React from 'react';
import { useMemo } from 'react';
import Text from '../text/text';
import styles from './table.module.scss';

const Table = ({ columns, data, isBatchGroup }) => {
  const renderColumns = useMemo(() => {
    return columns.map((c, i) => (
      <th key={i} style={{ textAlign: c.align || 'left', width: c.width }} className={classNames()}>
        {c.text}
      </th>
    ));
  }, [columns]);

  const renderRows = useMemo(() => {
    const rowContent = [];

    let lastBatchId = null;
    let stripeToggle = false; // false = stripedA, true = stripedB

    data.forEach((row, i) => {
      const currentBatchId = row.get('batchId');

      // Toggle stripe only if batchId changed (when grouped)
      if (isBatchGroup) {
        if (currentBatchId !== lastBatchId) {
          stripeToggle = !stripeToggle;
          lastBatchId = currentBatchId;
        }
      } else {
        stripeToggle = i % 2 === 1;
      }

      const stripeClass = stripeToggle ? styles.stripedB : styles.stripedA;

      rowContent.push(
        <tr key={i} className={stripeClass}>
          {columns.map((c, j) => {
            const content = row.get(c.key);
            return (
              <td key={j}>
                <div style={{ textAlign: c.align }}>{typeof content === 'string' ? <Text>{content}</Text> : content}</div>
              </td>
            );
          })}
        </tr>
      );
    });

    return rowContent;
  }, [columns, data, isBatchGroup]);

  return (
    <div className={styles.container}>
      <table className={styles.table}>
        <thead>
          <tr>{renderColumns}</tr>
        </thead>
        <tbody>{renderRows}</tbody>
      </table>
    </div>
  );
};

export default Table;
